var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { BaseIndicator, SecondaryText, Subtitle, } from "shared/lib/designSystem";
import colors from "shared/lib/designSystem/colors";
import theme from "shared/lib/designSystem/theme";
import styled from "styled-components";
import useAirdrop from "../../hooks/useAirdrop";
export var getAirdropColor = function (variant) {
    switch (variant) {
        case "discord":
            return colors.brands.discord;
        case "strangle":
        case "thetaVaultBase":
        case "thetaVaultBonus":
            return colors.red;
        default:
            return colors.green;
    }
};
var getAirdropTitle = function (variant) {
    switch (variant) {
        case "option":
            return "Options Trader";
        case "discord":
            return "DISCORD MEMBER";
        case "strangle":
            return "STRANGLE BUYER";
        case "thetaVaultBase":
            return "VAULT USER";
        case "thetaVaultBonus":
            return "VAULT USER BONUS";
    }
};
var BreakdownContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-wrap: wrap;\n  width: 100%;\n"])));
var BreakdownBackground = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", "14;\n  border-radius: 16px 16px 8px 8px;\n  margin: 16px 16px 0px 16px;\n  width: 100%;\n"], ["\n  background: ", "14;\n  border-radius: 16px 16px 8px 8px;\n  margin: 16px 16px 0px 16px;\n  width: 100%;\n"])), function (props) { return getAirdropColor(props.variant); });
var BreakdownPill = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border: ", " ", "\n    ", ";\n  border-radius: 100px;\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 8px 12px;\n  border: ", " ", "\n    ", ";\n  border-radius: 100px;\n"])), theme.border.width, theme.border.style, function (props) { return getAirdropColor(props.variant); });
var BreakdownPillToken = styled(Subtitle)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  margin-left: auto;\n"], ["\n  color: ", ";\n  margin-left: auto;\n"])), function (props) { return getAirdropColor(props.variant); });
var BreakdownPillDropdown = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n"])));
var AirdropBreakdown = function () {
    var airdrop = useAirdrop();
    var processedBreakdown = useMemo(function () {
        if (!airdrop) {
            return {};
        }
        return Object.fromEntries(Object.keys(airdrop.breakdown).map(function (key) { return [
            ["charm", "hegic", "opyn", "primitive"].includes(key) ? "option" : key,
            airdrop.breakdown[key],
        ]; }));
    }, [airdrop]);
    var renderBreakdownPill = useCallback(function (token, variant, index) { return (_jsxs(BreakdownBackground, __assign({ variant: variant }, { children: [_jsxs(BreakdownPill, __assign({ variant: variant }, { children: [_jsx(BaseIndicator, { size: 8, color: getAirdropColor(variant), className: "mr-2" }, void 0), _jsx(Subtitle, { children: getAirdropTitle(variant) }, void 0), _jsxs(BreakdownPillToken, __assign({ variant: variant }, { children: [token.toLocaleString(), " RBN"] }), void 0)] }), void 0), variant === "option" && (_jsx(BreakdownPillDropdown, { children: _jsx(SecondaryText, __assign({ color: getAirdropColor(variant) + "A3", fontSize: 12, lineHeight: 16, className: "text-center" }, { children: "Airdrop for being either a Charm seller, Opyn seller, Hegic LP or Primitive LP." }), void 0) }, void 0))] }), index)); }, []);
    return (_jsx(BreakdownContainer, { children: Object.keys(processedBreakdown).map(function (key, index) {
            return renderBreakdownPill(processedBreakdown[key] || 0, key, index);
        }) }, void 0));
};
export default AirdropBreakdown;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=AirdropBreakdown.js.map